import type { ApiUser } from '../types';

import type { TgimUserProfile } from './profile';
import type { TgimPublicUserProfile } from './users';

/** Maps backend profile fields onto an OpenIM `ApiUser` (Android `TgImUserProfileMerge`). */
export function applyTgimProfileToApiUser(
  user: ApiUser,
  profile: Pick<
  TgimUserProfile | TgimPublicUserProfile,
  'first_name' | 'last_name' | 'username' | 'avatar_url' | 'phone_e164'
  >,
): ApiUser {
  const firstName = (profile.first_name || '').trim();
  const lastName = (profile.last_name || '').trim();
  const username = typeof profile.username === 'string' ? profile.username.trim() : '';
  const avatarUrl = typeof profile.avatar_url === 'string' ? profile.avatar_url.trim() : '';
  const phone = typeof profile.phone_e164 === 'string' ? profile.phone_e164.trim() : '';

  return {
    ...user,
    firstName: firstName || user.firstName,
    lastName: lastName || undefined,
    avatarBlobUrl: avatarUrl || user.avatarBlobUrl,
    phoneNumber: phone || user.phoneNumber,
    usernames: username
      ? [{ username, isEditable: true, isActive: true }]
      : user.usernames,
  };
}

export function mapTgimPublicProfileToApiUser(profile: TgimPublicUserProfile): ApiUser {
  const firstName = (profile.first_name || '').trim();
  const lastName = (profile.last_name || '').trim();
  const username = typeof profile.username === 'string' ? profile.username.trim() : '';
  const avatarUrl = typeof profile.avatar_url === 'string' ? profile.avatar_url.trim() : '';
  const phone = typeof profile.phone_e164 === 'string' ? profile.phone_e164.trim() : '';

  return {
    id: profile.openim_user_id,
    isMin: false,
    type: 'userTypeRegular',
    firstName: firstName || lastName || profile.openim_user_id,
    lastName: lastName || undefined,
    phoneNumber: phone,
    noStatus: true,
    avatarBlobUrl: avatarUrl || undefined,
    usernames: username
      ? [{ username, isActive: true }]
      : undefined,
  };
}
